import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CustomVerticalTwoAndThreeSelectionData } from './custom-vertical-two-and-three-selection.model';
import {
  CustomCmsEventService
} from "src/app/spartacus/features/tracking/custom-events/checkout/cms/custom-cms-event.service";

@Component({
  selector: 'app-custom-vertical-two-and-three-selection',
  templateUrl: './custom-vertical-two-and-three-selection.component.html',
  styleUrls: ['./custom-vertical-two-and-three-selection.component.scss'],
  standalone: false
})
export class CustomVerticalTwoAndThreeSelectionComponent implements AfterViewInit, OnDestroy {
  animation = 'swipe';
  protected subscriptions: Subscription = new Subscription();

  constructor(
    protected componentData: CmsComponentData<CustomVerticalTwoAndThreeSelectionData>,
    private cmsService: CmsService,
    protected breakpointService: BreakpointService,
    private customCmsEventService: CustomCmsEventService,
  ) {
  }

  data$ = this.componentData.data$.pipe(map(component => component));
  items$: Observable<Observable<any>[]> = this.componentData.data$.pipe(
    map((data) => data?.items?.trim().split(' ').map((codes: string) => this.cmsService.getComponentData(codes))),
  );

  ngAfterViewInit(): void {
    this.subscriptions.add(
      this.items$.pipe(take(1)).subscribe(
        items => {
          const bannerList = this.customCmsEventService.getComponentList(items);
          this.customCmsEventService.dispatchViewPromotionEvent(bannerList);
        }
      )
    )
  }

  isDesktop(): Observable<boolean> {
    return this.breakpointService?.isUp(BREAKPOINT.md);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
